import BannerHeader from "../../../Components/BannerHeader/BannerHeader";
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav";
import classes from "./BookRestoration.module.css"
import { useEffect } from "react";
import WhyUs from "./WhyUs/WhyUs";
import RestorationSteps from "./RestorationSteps/RestorationSteps";
import Gallery from "../../Body/Gallery/Gallery";
import CustomerReview from "../../Body/CustomerReview/CutomerReview";
import FAQ from "../FAQ/FAQ";
import { ContactUs } from "../Components/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo";
import { useDispatch, useSelector } from "react-redux";
import { getAllFaq } from "../../../Store/actions/FaqAction";
import { urls } from "../../../Routes/Urls";
import useScrollToTop from "../../../Hooks/useScrollToTop";
import SEO from "../../../Components/SEO";

const banner = "/Assets/Images/ServicePages/BookRestoration.png"
const BookRestoration = () => {
    const crumbs = [
        {title:"Home",path:("/")},
        {title:"Book Restoration",path:urls.BOOKRESTORATION},
    ]

    const allFaqs = useSelector(state => state.Faq.questions)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const video = useSelector((state) => state.serviceVideo?.videos?.bookRestorationVideo)

    const dispatch = useDispatch()

    useEffect(() => {
        getAllFaq("category", "Book Restoration", "", dispatch);
    },[])

    const scrollRef = useScrollToTop();

    return(
        <>

            <SEO
                keywords="Book restoration Services"
                title="Book Repair Services & Old Book Restoration | Leather Book "
                description="Rare Biblio offers trusted book restoration services for your old, torn, or vintage books. Repair and preserve your collection with expert care—contact us now!"
                canonicalUrl="https://www.rarebiblio.com/book-restoration-services"
                structuredData={{
                    "@context": "https://schema.org",
                    "@graph": [
                      {
                        "@type": "Service",
                        "serviceType": "Book Restoration Services",
                        "name": "Book Restoration Services | Rare Biblio",
                        "description": "Revive and preserve your valuable books with Rare Biblio's professional book restoration services. We handle vintage, antique, and rare books with expert care.",
                        "provider": {
                          "@type": "Organization",
                          "name": "Rare Biblio",
                          "url": "https://www.rarebiblio.com/",
                          "logo": {
                            "@type": "ImageObject",
                            "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
                          },
                          "sameAs": [
                            "https://www.facebook.com/rarebiblio/",
                            "https://www.instagram.com/Rarebiblio/",
                            "https://www.linkedin.com/company/Rarebiblio",
                            "https://in.pinterest.com/rare_biblio/",
                            "https://x.com/Rarebiblio"
                          ]
                        },
                        "areaServed": {
                          "@type": "Place",
                          "name": "Worldwide"
                        },
                        "url": "https://www.rarebiblio.com/book-restoration-services",
                        "category": "Book Restoration"
                      },
                      {
                        "@type": "FAQPage",
                        "mainEntity": [
                          {
                            "@type": "Question",
                            "name": "What types of damage can you restore?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "We specialize in restoring a variety of damages, including cracked or torn leather, broken spines, and more. Whether it’s a cherished family heirloom or a favorite book that needs some TLC, we can help bring it back to life."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "How long does the book restoration process take?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "Restoration times vary depending on the extent of the damage. On average, the process takes 2-4 weeks. However, if you have a specific deadline, feel free to reach out, and we will do our best to accommodate your needs."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "Is the book restored to its original appearance, or can I request custom changes?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "We aim to restore your book to its original state, but if you’d like to incorporate custom changes (such as adding new colors, designs, or modern touches), we can discuss your preferences. Our goal is to make sure you’re happy with the final result."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "How do I send my book to you for restoration?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "To send your book for restoration, simply contact us to discuss the details of the damage and your restoration needs. We’ll provide you with instructions on how to safely package and ship your book to us. Once we receive it, we’ll start the restoration process and keep you updated along the way."
                            }
                          }
                        ]
                      }
                    ]
                  }}
            />
        <div ref={scrollRef}>
            <PrimaryNav />
            <BannerHeader
                title={'Book Restoration Service'}
                desc={"Renewing Classics, Preserving Memories"}
                crumbs={crumbs}
                bgImage={banner} 
            />

            <ServiceVideo videoSrc={video} 
            title={"Restoration of old books"} 
            desc={"Your old and worn-out books are meant to be given a second chance through our restoration process. Our talented artisans are experts and specialize in the fine craft of leather-bound book restoration and can bring your old book to life. "}/>

            <WhyUs />

            <RestorationSteps />

            <div className={classes.ContactUs}>
                <ContactUs category={"bookRestoration"} />
            </div>

            <Gallery />

            <CustomerReview />

            
            <FAQ data={allFaqs} category={"Book Restoration"}/>

           

            <Footer />

        </div>
        </>
    )
}

export default BookRestoration;